<template>
  <v-container class="hotsheet-page">
    <template v-if="loading">
      <v-progress-circular
        indeterminate
        color="primary"
      />
    </template>
    <template v-else-if="project">
      <v-toolbar color="primary" dark flat>
        <v-toolbar-title>{{ project.name }}</v-toolbar-title>
        <v-spacer />
        <v-toolbar-items>
          <v-btn
            flat
            small
            @click="hideCompletedItems = !hideCompletedItems">
            <span v-if="hideCompletedItems">Show Completed Items</span>
            <span v-else>Hide Completed Items</span>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-card>
        <v-container>
          <template v-if="!project.hotsheet.length">
            Nothing here yet.
          </template>
          <template v-else>
            <div
              v-for="(item, itemIdx) in project.hotsheet"
              :key="item.id"
              v-if="!hideCompletedItems || !item.completed"
              class="hotsheet-page-project-hotsheet-item"
              :class="itemClassnames(item, itemIdx)"
            >
              <h2 class="item-heading" v-if="item.type === 'heading'">{{ item.description }}</h2>
              <template v-else-if="item.type === 'item'">
                <v-layout>
                  <v-flex v-if="item.responsibleParty" class="mr-5" shrink>
                    <v-chip
                      class="ma-0 mb-2"
                      :color="item.completed ? 'grey lighten-5' : 'grey lighten-2'"
                      :text-color="item.completed ? 'grey lighten-1' : 'grey darken-2'"
                      small
                    >
                      {{ item.responsibleParty }}
                    </v-chip>
                  </v-flex>
                  <v-flex align-self-center>
                    <div
                      class="markdown-body"
                      :class="{ 'grey--text text--lighten-2': item.completed }"
                      v-html="markdownToHtml(item.description)" />
                  </v-flex>
                </v-layout>
              </template>
            </div>
          </template>
        </v-container>
      </v-card>
    </template>
    <template v-else>
      Error loading.
    </template>
  </v-container>
</template>

<script>
import api from '../api'
import renderMarkdown from '../markdown/renderMarkdown'

export default {
  metaInfo() {
    return {
      title: this.project ? `${this.project.name} Hotsheet` : 'Hotsheet',
    }
  },

  props: ['routeProjectId', 'routePassword'],

  data() {
    return {
      loading: false,
      error: '',
      project: null,
      hideCompletedItems: false,
    }
  },

  methods: {
    load() {
      this.loading = true
      api.endpoints.project_hotsheet
        .get(this.routeProjectId, this.routePassword)
        .then(({ data }) => {
          this.project = data
        })
        .catch(() => {
        })
        .then(() => {
          this.loading = false
        })
    },

    markdownToHtml(markdown) {
      if (!markdown) {
        return ''
      }

      return renderMarkdown(markdown)
    },

    itemClassnames(item, itemIdx) {
      const classes = {
        'is-first-item': itemIdx === 0,
        'is-completed': item.completed,
      }

      classes[`is-${item.type}`] = true

      const nextItem = this.project.hotsheet[itemIdx + 1]
      if (nextItem) {
        classes[`next-is-${nextItem.type}`] = true
      }

      return classes
    },
  },

  created() {
    this.load()
  },
}
</script>

<style>
.hotsheet-page-project-hotsheet-item {
  padding: 2rem 0;
  position: relative;
}

.hotsheet-page-project-hotsheet-item.is-first-item {
  padding-top: 0;
}

.hotsheet-page-project-hotsheet-item.is-heading::after {
  content: '';
  position: absolute;
  top: 0;
  left: -20px;
  right: -20px;
  height: 1px;
  background: #ccc;
}

.hotsheet-page-project-hotsheet-item.is-heading.is-first-item::after {
  display: none;
}

.hotsheet-page-project-hotsheet-item.is-heading.next-is-item {
  padding-bottom: 0;
}

.hotsheet-page-project-hotsheet-item.is-completed .markdown-body {
  text-decoration: line-through;
}

@media print {
  .hotsheet-page.container,
  .hotsheet-page .container {
    padding: 0 !important;
  }

  .hotsheet-page .v-toolbar__content {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }

  .hotsheet-page .v-toolbar__title {
    color: inherit !important;
  }

  .hotsheet-page .v-toolbar__items {
    display: none !important;
  }

  .hotsheet-page .v-card {
    box-shadow: none !important;
  }

  .hotsheet-page-project-hotsheet-item {
    padding: 1rem 0;
  }
}
</style>
